import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    data: null,
    isFetching: false,
    isError: false
};
var createReservationSlice = createSlice({
    name: "createReservation",
    initialState: initialState,
    reducers: {
        fetchData: function(state) {
            state.isFetching = true;
            state.data = null;
            state.isError = false;
        },
        fetchDataSuccess: function(state, action) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                data: action.payload
            });
        },
        fetchDataFailure: function(state) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                isError: true
            });
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _createReservationSlice_actions = createReservationSlice.actions;
export var fetchData = _createReservationSlice_actions.fetchData, fetchDataSuccess = _createReservationSlice_actions.fetchDataSuccess, fetchDataFailure = _createReservationSlice_actions.fetchDataFailure, resetState = _createReservationSlice_actions.resetState;
export default createReservationSlice.reducer;
